export enum SrcType {
    Legacy = 0,
    CincSocial = 1
}
